module.exports = [{
      plugin: require('../../../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-scroll-position/gatsby-browser.js'),
      options: {"plugins":[],"elements":[{"selector":"#portal-sidebar-menu","ensureInView":"#portal-sidebar-menu ul li.is-active > .dnb-sidebar-menu__item"}]},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-eufemia-theme-handler/gatsby-browser.js'),
      options: {"plugins":[],"themes":{"ui":{"name":"DNB"},"eiendom":{"name":"DNB Eiendom"},"sbanken":{"name":"Sbanken (WIP)"},"carnegie":{"name":"Carnegie (WIP)"}},"filesGlobs":["**/src/style/dnb-ui-core.scss","**/src/style/themes/**/*-theme-{basis,components}.scss","**/src/extensions/payment-card/**/dnb-*.scss"],"includeFiles":["**/dnb-ui-core*","**/dnb-ui-basis*","**/*-theme-components*","**/*-theme-basis*","**/payment-card/**/*"],"defaultTheme":"ui","wrapWithThemeProvider":false,"omitScrollBehavior":true,"storageId":"eufemia-theme","themeMatchers":[{}],"inlineDefaultTheme":true,"verbose":false},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
